import { isToolUIPart, type UIMessage } from "ai";

/**
 * Whether a tool the agent called ended the call: hanging up, transferring, or
 * a tool that ends the call when it succeeds.
 */
export function checkSimulationCallEnded(
  messages: readonly UIMessage[],
): boolean {
  return messages.some(
    (message) =>
      message.role === "assistant" &&
      message.parts.some(
        (part) =>
          isToolUIPart(part) &&
          part.state === "output-available" &&
          typeof part.output === "object" &&
          part.output !== null &&
          "isEndOfCall" in part.output &&
          part.output.isEndOfCall === true,
      ),
  );
}

/**
 * Replace a failed turn, including any partial streamed assistant output, with
 * its retryable error message while preserving the user message that began it.
 */
export function replaceFailedSimulationTurn(
  messages: readonly UIMessage[],
  errorMessage: UIMessage,
): UIMessage[] {
  const lastUserMessageIndex = messages.findLastIndex(
    (message) => message.role === "user",
  );
  return [...messages.slice(0, lastUserMessageIndex + 1), errorMessage];
}
